import type { DateTime } from '@piccolohealth/util';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: DateTime; output: DateTime };
  JSON: { input: any; output: any };
};

export type AbcMethod = {
  __typename?: 'AbcMethod';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  templates: AbcTemplate;
};

export type AbcRecordingRequest = {
  antecedent: Scalars['String']['input'];
  behaviour: Scalars['String']['input'];
  consequence: Scalars['String']['input'];
};

export type AbcTemplate = {
  __typename?: 'AbcTemplate';
  antecedent: Array<Scalars['String']['output']>;
  behaviour: Array<Scalars['String']['output']>;
  consequence: Array<Scalars['String']['output']>;
};

export enum AggregationType {
  Average = 'Average',
  Max = 'Max',
  Min = 'Min',
  Sum = 'Sum',
}

export type AuditTrailEntry = {
  __typename?: 'AuditTrailEntry';
  createdAt: Scalars['DateTime']['output'];
  event: AuditTrailEvent;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  payload: Scalars['JSON']['output'];
  timestamp: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export enum AuditTrailEvent {
  BehaviourCreated = 'BEHAVIOUR_CREATED',
  BehaviourDeleted = 'BEHAVIOUR_DELETED',
  BehaviourUpdated = 'BEHAVIOUR_UPDATED',
  FormCreated = 'FORM_CREATED',
  FormDeleted = 'FORM_DELETED',
  FormUpdated = 'FORM_UPDATED',
  IncidentsExported = 'INCIDENTS_EXPORTED',
  IncidentCategoryCreated = 'INCIDENT_CATEGORY_CREATED',
  IncidentCategoryDeleted = 'INCIDENT_CATEGORY_DELETED',
  IncidentCategoryUpdated = 'INCIDENT_CATEGORY_UPDATED',
  IncidentCreated = 'INCIDENT_CREATED',
  IncidentDeleted = 'INCIDENT_DELETED',
  IncidentFileCreated = 'INCIDENT_FILE_CREATED',
  IncidentFileDeleted = 'INCIDENT_FILE_DELETED',
  IncidentFileUpdated = 'INCIDENT_FILE_UPDATED',
  IncidentLabelCreated = 'INCIDENT_LABEL_CREATED',
  IncidentLabelDeleted = 'INCIDENT_LABEL_DELETED',
  IncidentStatusUpdated = 'INCIDENT_STATUS_UPDATED',
  IncidentUpdated = 'INCIDENT_UPDATED',
  LabelCreated = 'LABEL_CREATED',
  LabelDeleted = 'LABEL_DELETED',
  LabelUpdated = 'LABEL_UPDATED',
  LocationCreated = 'LOCATION_CREATED',
  LocationDeleted = 'LOCATION_DELETED',
  LocationUpdated = 'LOCATION_UPDATED',
  LocationUserCreated = 'LOCATION_USER_CREATED',
  LocationUserDeleted = 'LOCATION_USER_DELETED',
  LocationUserUpdated = 'LOCATION_USER_UPDATED',
  OrganizationUpdated = 'ORGANIZATION_UPDATED',
  ParticipantsExported = 'PARTICIPANTS_EXPORTED',
  ParticipantBehaviourCreated = 'PARTICIPANT_BEHAVIOUR_CREATED',
  ParticipantBehaviourDeleted = 'PARTICIPANT_BEHAVIOUR_DELETED',
  ParticipantBehaviourRecordingCreated = 'PARTICIPANT_BEHAVIOUR_RECORDING_CREATED',
  ParticipantBehaviourRecordingDeleted = 'PARTICIPANT_BEHAVIOUR_RECORDING_DELETED',
  ParticipantBehaviourRecordingMethodCreated = 'PARTICIPANT_BEHAVIOUR_RECORDING_METHOD_CREATED',
  ParticipantBehaviourRecordingMethodDeleted = 'PARTICIPANT_BEHAVIOUR_RECORDING_METHOD_DELETED',
  ParticipantBehaviourRecordingMethodUpdated = 'PARTICIPANT_BEHAVIOUR_RECORDING_METHOD_UPDATED',
  ParticipantBehaviourRecordingUpdated = 'PARTICIPANT_BEHAVIOUR_RECORDING_UPDATED',
  ParticipantBehaviourUpdated = 'PARTICIPANT_BEHAVIOUR_UPDATED',
  ParticipantCreated = 'PARTICIPANT_CREATED',
  ParticipantDeleted = 'PARTICIPANT_DELETED',
  ParticipantDocumentCloned = 'PARTICIPANT_DOCUMENT_CLONED',
  ParticipantDocumentCreated = 'PARTICIPANT_DOCUMENT_CREATED',
  ParticipantDocumentDeleted = 'PARTICIPANT_DOCUMENT_DELETED',
  ParticipantDocumentLabelCreated = 'PARTICIPANT_DOCUMENT_LABEL_CREATED',
  ParticipantDocumentLabelDeleted = 'PARTICIPANT_DOCUMENT_LABEL_DELETED',
  ParticipantDocumentUpdated = 'PARTICIPANT_DOCUMENT_UPDATED',
  ParticipantEmbeddableFormCreated = 'PARTICIPANT_EMBEDDABLE_FORM_CREATED',
  ParticipantEmbeddableFormDeleted = 'PARTICIPANT_EMBEDDABLE_FORM_DELETED',
  ParticipantEmbeddableFormUpdated = 'PARTICIPANT_EMBEDDABLE_FORM_UPDATED',
  ParticipantExported = 'PARTICIPANT_EXPORTED',
  ParticipantFastForwarded = 'PARTICIPANT_FAST_FORWARDED',
  ParticipantFieldGroupTemplateCreated = 'PARTICIPANT_FIELD_GROUP_TEMPLATE_CREATED',
  ParticipantFieldGroupTemplateDeleted = 'PARTICIPANT_FIELD_GROUP_TEMPLATE_DELETED',
  ParticipantFieldGroupTemplateUpdated = 'PARTICIPANT_FIELD_GROUP_TEMPLATE_UPDATED',
  ParticipantFieldGroupUpdated = 'PARTICIPANT_FIELD_GROUP_UPDATED',
  ParticipantFieldTemplateCreated = 'PARTICIPANT_FIELD_TEMPLATE_CREATED',
  ParticipantFieldTemplateDeleted = 'PARTICIPANT_FIELD_TEMPLATE_DELETED',
  ParticipantFieldTemplateUpdated = 'PARTICIPANT_FIELD_TEMPLATE_UPDATED',
  ParticipantFileCreated = 'PARTICIPANT_FILE_CREATED',
  ParticipantFileDeleted = 'PARTICIPANT_FILE_DELETED',
  ParticipantFileLabelCreated = 'PARTICIPANT_FILE_LABEL_CREATED',
  ParticipantFileLabelDeleted = 'PARTICIPANT_FILE_LABEL_DELETED',
  ParticipantFileUpdated = 'PARTICIPANT_FILE_UPDATED',
  ParticipantLabelCreated = 'PARTICIPANT_LABEL_CREATED',
  ParticipantLabelDeleted = 'PARTICIPANT_LABEL_DELETED',
  ParticipantNoteCloned = 'PARTICIPANT_NOTE_CLONED',
  ParticipantNoteCreated = 'PARTICIPANT_NOTE_CREATED',
  ParticipantNoteDeleted = 'PARTICIPANT_NOTE_DELETED',
  ParticipantNoteUpdated = 'PARTICIPANT_NOTE_UPDATED',
  ParticipantQrCreated = 'PARTICIPANT_QR_CREATED',
  ParticipantQrDeleted = 'PARTICIPANT_QR_DELETED',
  ParticipantQrLabelCreated = 'PARTICIPANT_QR_LABEL_CREATED',
  ParticipantQrLabelDeleted = 'PARTICIPANT_QR_LABEL_DELETED',
  ParticipantQrUpdated = 'PARTICIPANT_QR_UPDATED',
  ParticipantRestrictivePracticeCreated = 'PARTICIPANT_RESTRICTIVE_PRACTICE_CREATED',
  ParticipantRestrictivePracticeDeleted = 'PARTICIPANT_RESTRICTIVE_PRACTICE_DELETED',
  ParticipantRestrictivePracticeLabelCreated = 'PARTICIPANT_RESTRICTIVE_PRACTICE_LABEL_CREATED',
  ParticipantRestrictivePracticeLabelDeleted = 'PARTICIPANT_RESTRICTIVE_PRACTICE_LABEL_DELETED',
  ParticipantRestrictivePracticeUpdated = 'PARTICIPANT_RESTRICTIVE_PRACTICE_UPDATED',
  ParticipantTaskCreated = 'PARTICIPANT_TASK_CREATED',
  ParticipantTaskDeleted = 'PARTICIPANT_TASK_DELETED',
  ParticipantTaskLabelCreated = 'PARTICIPANT_TASK_LABEL_CREATED',
  ParticipantTaskLabelDeleted = 'PARTICIPANT_TASK_LABEL_DELETED',
  ParticipantTaskTemplateCreated = 'PARTICIPANT_TASK_TEMPLATE_CREATED',
  ParticipantTaskTemplateDeleted = 'PARTICIPANT_TASK_TEMPLATE_DELETED',
  ParticipantTaskTemplateLabelCreated = 'PARTICIPANT_TASK_TEMPLATE_LABEL_CREATED',
  ParticipantTaskTemplateLabelDeleted = 'PARTICIPANT_TASK_TEMPLATE_LABEL_DELETED',
  ParticipantTaskTemplateUpdated = 'PARTICIPANT_TASK_TEMPLATE_UPDATED',
  ParticipantTaskUpdated = 'PARTICIPANT_TASK_UPDATED',
  ParticipantUpdated = 'PARTICIPANT_UPDATED',
  ParticipantUsersCreated = 'PARTICIPANT_USERS_CREATED',
  ParticipantUserCreated = 'PARTICIPANT_USER_CREATED',
  ParticipantUserDeleted = 'PARTICIPANT_USER_DELETED',
  ParticipantUserUpdated = 'PARTICIPANT_USER_UPDATED',
  ParticipantWidgetLayoutItemsUpdated = 'PARTICIPANT_WIDGET_LAYOUT_ITEMS_UPDATED',
  TemplateCreated = 'TEMPLATE_CREATED',
  TemplateDeleted = 'TEMPLATE_DELETED',
  TemplateUpdated = 'TEMPLATE_UPDATED',
  UserDeleted = 'USER_DELETED',
  UserInvited = 'USER_INVITED',
  UserUpdated = 'USER_UPDATED',
}

export type AuthedRecordingApp = {
  __typename?: 'AuthedRecordingApp';
  createParticipantBehaviourRecording: ParticipantBehaviourRecording;
  deleteParticipantBehaviourRecording: Maybe<ParticipantBehaviourRecording>;
  organization: Maybe<OrganizationRecordingInfo>;
  organizations: Array<OrganizationRecordingInfo>;
  updateParticipantBehaviourRecording: ParticipantBehaviourRecording;
};

export type AuthedRecordingAppCreateParticipantBehaviourRecordingArgs = {
  organizationId: Scalars['ID']['input'];
  participantBehaviourId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  request: CreateParticipantBehaviourRecordingRequest;
};

export type AuthedRecordingAppDeleteParticipantBehaviourRecordingArgs = {
  organizationId: Scalars['ID']['input'];
  participantBehaviourId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  recordingId: Scalars['ID']['input'];
};

export type AuthedRecordingAppOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};

export type AuthedRecordingAppUpdateParticipantBehaviourRecordingArgs = {
  organizationId: Scalars['ID']['input'];
  participantBehaviourId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  recordingId: Scalars['ID']['input'];
  request: UpdateParticipantBehaviourRecordingRequest;
};

export type BarTimeSeries = {
  __typename?: 'BarTimeSeries';
  aggregation: AggregationType;
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: DataSource;
};

export type BehaviourRecordingRequestPayload = {
  abc?: InputMaybe<AbcRecordingRequest>;
  duration?: InputMaybe<DurationRecordingRequest>;
  episodicSeverity?: InputMaybe<EpisodicSeverityRecordingRequest>;
  frequency?: InputMaybe<FrequencyRecordingRequest>;
};

export type BillingAction = {
  __typename?: 'BillingAction';
  createdAt: Scalars['DateTime']['output'];
  id: BillingActionType;
  stripeProductId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum BillingActionType {
  AiScoringInputToken = 'AiScoringInputToken',
  AiScoringOutputToken = 'AiScoringOutputToken',
  Participant = 'Participant',
}

export type BillingProduct = {
  __typename?: 'BillingProduct';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BillingSubscriptionItem = {
  __typename?: 'BillingSubscriptionItem';
  id: Scalars['ID']['output'];
  product: BillingProduct;
};

export type CreateAbcMethodsRequest = {
  enabled: Scalars['Boolean']['input'];
  templates: CreateAbcTemplateRequest;
};

export type CreateAbcTemplateRequest = {
  antecedent: Array<Scalars['String']['input']>;
  behaviour: Array<Scalars['String']['input']>;
  consequence: Array<Scalars['String']['input']>;
};

export type CreateAuditTrailEntryRequest = {
  __typename?: 'CreateAuditTrailEntryRequest';
  event: AuditTrailEvent;
  message: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  payload: Maybe<Scalars['JSON']['output']>;
  user: User;
};

export type CreateBehaviourRequest = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type CreateDurationMethodsRequest = {
  enabled: Scalars['Boolean']['input'];
};

export type CreateEpisodicSeverityMethodsRequest = {
  enabled: Scalars['Boolean']['input'];
  scales: Array<CreateEpisodicSeverityScaleRequest>;
};

export type CreateEpisodicSeverityScaleRequest = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type CreateFormRequest = {
  externalId: Scalars['String']['input'];
  labelMappings: FormLabelMappingsRequest;
  name: Scalars['String']['input'];
  type: FormType;
  url: Scalars['String']['input'];
};

export type CreateFrequencyMethodsRequest = {
  enabled: Scalars['Boolean']['input'];
};

export type CreateIncidentCategoryRequest = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateIncidentRequest = {
  categoryId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  labelIds: Array<Scalars['ID']['input']>;
  ndisReportableIncident: Scalars['Boolean']['input'];
  participantId?: InputMaybe<Scalars['ID']['input']>;
  reviewerIds: Array<Scalars['ID']['input']>;
  setting: Scalars['String']['input'];
  severity: IncidentSeverity;
  timestamp: Scalars['DateTime']['input'];
  witnesses: Array<CreateIncidentWitnessInput>;
};

export type CreateIncidentWitnessInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLabelRequest = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: LabelType;
};

export type CreateLocationRequest = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateOrganizationRequest = {
  featureFlags?: InputMaybe<Array<FeatureFlag>>;
  locale: Scalars['String']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  mfaPolicy: MfaPolicy;
  name: Scalars['String']['input'];
  status: OrganizationStatus;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  supportEmail: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export type CreateParticipantBehaviourMethodsRequest = {
  abc: CreateAbcMethodsRequest;
  duration: CreateDurationMethodsRequest;
  episodicSeverity: CreateEpisodicSeverityMethodsRequest;
  frequency: CreateFrequencyMethodsRequest;
};

export type CreateParticipantBehaviourRecordingRequest = {
  comment?: InputMaybe<Scalars['String']['input']>;
  payload: BehaviourRecordingRequestPayload;
  timestamp: Scalars['DateTime']['input'];
};

export type CreateParticipantBehaviourRequest = {
  description: Scalars['String']['input'];
  example: Scalars['String']['input'];
  methods: CreateParticipantBehaviourMethodsRequest;
  name: Scalars['String']['input'];
  nonExample: Scalars['String']['input'];
  participantId: Scalars['ID']['input'];
  status: ParticipantBehaviourStatus;
};

export type CreateParticipantDocumentRequest = {
  authorIds: Array<Scalars['ID']['input']>;
  labelIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  participantId: Scalars['ID']['input'];
  reviewerIds: Array<Scalars['ID']['input']>;
  status: ParticipantDocumentStatus;
  templateId: Scalars['ID']['input'];
};

export type CreateParticipantEmbeddableFormRequest = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateParticipantFieldGroupRequest = {
  fields: Array<CreateParticipantFieldRequest>;
  participantFieldGroupTemplateId: Scalars['ID']['input'];
};

export type CreateParticipantFieldGroupTemplateRequest = {
  index: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type CreateParticipantFieldRequest = {
  participantFieldTemplateId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateParticipantFieldTemplateRequest = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  index: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  participantFieldGroupTemplateId: Scalars['ID']['input'];
  type: FieldTemplateType;
};

export type CreateParticipantKeyContactRequest = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateParticipantNoteRequest = {
  id?: InputMaybe<Scalars['ID']['input']>;
  labelIds: Array<Scalars['ID']['input']>;
  participantId: Scalars['ID']['input'];
  templateId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateParticipantQrBehaviourMethodsRequest = {
  abc: CreateQrAbcMethodsRequest;
  duration: CreateQrDurationMethodsRequest;
  episodicSeverity: CreateQrEpisodicSeverityMethodsRequest;
  frequency: CreateQrFrequencyMethodsRequest;
};

export type CreateParticipantQrBehaviourRequest = {
  behaviourId: Scalars['ID']['input'];
  methods: CreateParticipantQrBehaviourMethodsRequest;
};

export type CreateParticipantQrRequest = {
  behaviours: Array<CreateParticipantQrBehaviourRequest>;
  embeddableFormIds: Array<Scalars['ID']['input']>;
  labelIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  status: ParticipantQrStatus;
};

export type CreateParticipantRequest = {
  address?: InputMaybe<Scalars['String']['input']>;
  dob: Scalars['DateTime']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  fieldGroups: Array<CreateParticipantFieldGroupRequest>;
  firstName: Scalars['String']['input'];
  gender: Gender;
  keyContacts: Array<CreateParticipantKeyContactRequest>;
  labelIds: Array<Scalars['ID']['input']>;
  lastName: Scalars['String']['input'];
  locationId: Scalars['ID']['input'];
  ndisNumber?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status: ParticipantStatus;
  suburb?: InputMaybe<Scalars['String']['input']>;
};

export type CreateParticipantRestrictivePracticeRequest = {
  ceasedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  identifiedAt: Scalars['DateTime']['input'];
  labelIds: Array<Scalars['ID']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type: RestrictivePracticeType;
};

export type CreateParticipantTaskRecurrenceRequest = {
  intervalDays: Scalars['Int']['input'];
};

export type CreateParticipantTaskRequest = {
  assigneeIds: Array<Scalars['ID']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  labelIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  recurrence?: InputMaybe<CreateParticipantTaskRecurrenceRequest>;
  requiresDueDate: Scalars['Boolean']['input'];
};

export type CreateParticipantTaskTemplateRequest = {
  labelIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  recurrence?: InputMaybe<CreateParticipantTaskRecurrenceRequest>;
  requiresDueDate: Scalars['Boolean']['input'];
};

export type CreateParticipantTasksFromTemplatesRequest = {
  taskTemplateIds: Array<Scalars['ID']['input']>;
};

export type CreateParticipantUserRequest = {
  labelIds: Array<Scalars['ID']['input']>;
  participantId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type CreateQrAbcMethodsRequest = {
  enabled: Scalars['Boolean']['input'];
};

export type CreateQrDurationMethodsRequest = {
  enabled: Scalars['Boolean']['input'];
};

export type CreateQrEpisodicSeverityMethodsRequest = {
  enabled: Scalars['Boolean']['input'];
};

export type CreateQrFrequencyMethodsRequest = {
  enabled: Scalars['Boolean']['input'];
};

export type CreateTemplateRequest = {
  labelIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  status: TemplateStatus;
  type: TemplateType;
};

export type CriteriaLabel = {
  __typename?: 'CriteriaLabel';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DataSource = ParticipantBehaviourDataSource;

export type DurationMethod = {
  __typename?: 'DurationMethod';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type DurationRecordingRequest = {
  value: Scalars['Int']['input'];
};

export type EpisodicSeverityMethod = {
  __typename?: 'EpisodicSeverityMethod';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  scales: Array<EpisodicSeverityScale>;
};

export type EpisodicSeverityRecordingRequest = {
  level: Scalars['Int']['input'];
};

export type EpisodicSeverityScale = {
  __typename?: 'EpisodicSeverityScale';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ExportParticipantRequest = {
  behaviourRecordings?: InputMaybe<Scalars['Boolean']['input']>;
  documents?: InputMaybe<Scalars['Boolean']['input']>;
  files?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['Boolean']['input']>;
  profile?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ExtraPermission {
  Support = 'SUPPORT',
}

export enum FeatureFlag {
  Placeholder = 'PLACEHOLDER',
  TemplateScoring = 'TEMPLATE_SCORING',
}

export enum FieldTemplateType {
  Datepicker = 'DATEPICKER',
  Input = 'INPUT',
  MultiSelect = 'MULTI_SELECT',
  Select = 'SELECT',
  Textarea = 'TEXTAREA',
}

export type Form = {
  __typename?: 'Form';
  externalId: Maybe<Scalars['String']['output']>;
  formResponses: Array<FormResponse>;
  id: Scalars['ID']['output'];
  labelMappings: FormLabelMappings;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  type: FormType;
  url: Maybe<Scalars['String']['output']>;
};

export enum FormEvent {
  Create = 'Create',
  Update = 'Update',
}

export type FormLabelMappings = {
  __typename?: 'FormLabelMappings';
  create: Array<Label>;
  update: Array<Label>;
};

export type FormLabelMappingsRequest = {
  create: Array<Scalars['ID']['input']>;
  update: Array<Scalars['ID']['input']>;
};

export type FormResponse = {
  __typename?: 'FormResponse';
  createdAt: Scalars['DateTime']['output'];
  errorMessage: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  response: Scalars['JSON']['output'];
  status: FormResponseStatus;
  submissionId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum FormResponseStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Success = 'SUCCESS',
}

export enum FormType {
  Participant = 'Participant',
}

export type FrequencyMethod = {
  __typename?: 'FrequencyMethod';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type FrequencyRecordingRequest = {
  value: Scalars['Int']['input'];
};

export enum Gender {
  Female = 'Female',
  GenderNeutral = 'GenderNeutral',
  Male = 'Male',
  NonBinary = 'NonBinary',
  NotSpecified = 'NotSpecified',
  Transgender = 'Transgender',
}

export type GetPaginatedAuditTrailEntriesRequest = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  events?: InputMaybe<Array<AuditTrailEvent>>;
  message?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<TimestampPaginationRequest>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  users?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetPaginatedIncidentsRequest = {
  category?: InputMaybe<Array<Scalars['ID']['input']>>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  labels?: InputMaybe<Array<Scalars['ID']['input']>>;
  location?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<PaginationRequest>;
  participant?: InputMaybe<Array<Scalars['ID']['input']>>;
  severity?: InputMaybe<Array<IncidentSeverity>>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<IncidentStatus>>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetPaginatedParticipantAuditTrailEntriesRequest = {
  pagination?: InputMaybe<TimestampPaginationRequest>;
};

export type GetPaginatedParticipantDocumentVersionsRequest = {
  pagination?: InputMaybe<PaginationRequest>;
};

export type GetPaginatedParticipantNoteVersionsRequest = {
  pagination?: InputMaybe<PaginationRequest>;
};

export type GetPaginatedParticipantNotesRequest = {
  content?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<PaginationRequest>;
};

export type GetPaginatedParticipantsRequest = {
  assignedTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedToLabel?: InputMaybe<Array<Scalars['ID']['input']>>;
  dob?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  hasBehaviours?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['ID']['input']>>;
  location?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  ndisNumber?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationRequest>;
  qrs?: InputMaybe<Array<Scalars['ID']['input']>>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Array<ParticipantStatus>>;
};

export type GetPaginatedTemplateVersionsRequest = {
  pagination?: InputMaybe<PaginationRequest>;
};

export type GetPaginatedTemplatesRequest = {
  labels?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationRequest>;
  status?: InputMaybe<Array<TemplateStatus>>;
  type?: InputMaybe<Array<TemplateType>>;
};

export type GetPaginatedUsersRequest = {
  name?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationRequest>;
  participantId?: InputMaybe<Scalars['ID']['input']>;
  roles?: InputMaybe<Array<Role>>;
};

export type GetParticipantRecordingInfoRequest = {
  name?: InputMaybe<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationRequest>;
  qrIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Incident = {
  __typename?: 'Incident';
  actions: Maybe<Scalars['String']['output']>;
  category: IncidentCategory;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  files: Array<IncidentFile>;
  id: Scalars['ID']['output'];
  labels: Array<Label>;
  location: Maybe<Location>;
  ndisReportableIncident: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  participant: Maybe<Participant>;
  reporter: User;
  reviewers: Array<User>;
  setting: Scalars['String']['output'];
  severity: IncidentSeverity;
  shortId: Scalars['Int']['output'];
  status: IncidentStatus;
  timestamp: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
  witnesses: Array<IncidentWitness>;
};

export type IncidentCategory = {
  __typename?: 'IncidentCategory';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type IncidentFile = {
  __typename?: 'IncidentFile';
  createdAt: Scalars['DateTime']['output'];
  downloadUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  incidentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploader: User;
  viewUrl: Scalars['String']['output'];
};

export enum IncidentSeverity {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
}

export enum IncidentStatus {
  AwaitingReview = 'AwaitingReview',
  Reviewed = 'Reviewed',
}

export type IncidentWitness = {
  __typename?: 'IncidentWitness';
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type InviteUserRequest = {
  email: Scalars['String']['input'];
  featureFlags: Array<FeatureFlag>;
  locations: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  picture?: InputMaybe<Scalars['String']['input']>;
  practitionerNumber?: InputMaybe<Scalars['String']['input']>;
  roles: Array<Role>;
  title: Scalars['String']['input'];
};

export type Job = {
  __typename?: 'Job';
  completedOn: Maybe<Scalars['DateTime']['output']>;
  createdOn: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  response: Maybe<Scalars['JSON']['output']>;
  startedOn: Maybe<Scalars['DateTime']['output']>;
  state: JobState;
};

export enum JobState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Retry = 'RETRY',
}

export type Label = {
  __typename?: 'Label';
  color: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  type: LabelType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum LabelType {
  Incident = 'Incident',
  Participant = 'Participant',
  ParticipantDocument = 'ParticipantDocument',
  ParticipantKeyContact = 'ParticipantKeyContact',
  ParticipantNote = 'ParticipantNote',
  ParticipantQr = 'ParticipantQr',
  ParticipantRestrictivePractice = 'ParticipantRestrictivePractice',
  ParticipantTask = 'ParticipantTask',
  ParticipantUser = 'ParticipantUser',
  ScoringCriteria = 'ScoringCriteria',
  Template = 'Template',
}

export type LineTimeSeries = {
  __typename?: 'LineTimeSeries';
  aggregation: AggregationType;
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: DataSource;
  symbol: SymbolType;
  trendline: Maybe<Trendline>;
};

export type Location = {
  __typename?: 'Location';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum MfaEnrolment {
  Phone = 'PHONE',
  Totp = 'TOTP',
}

export type Method = AbcMethod | DurationMethod | EpisodicSeverityMethod | FrequencyMethod;

export enum MethodType {
  Abc = 'Abc',
  Duration = 'Duration',
  EpisodicSeverity = 'EpisodicSeverity',
  Frequency = 'Frequency',
}

export enum MfaPolicy {
  Optional = 'OPTIONAL',
  Required = 'REQUIRED',
}

export type Mutation = {
  __typename?: 'Mutation';
  cloneParticipantDocument: ParticipantDocument;
  cloneParticipantNote: ParticipantNote;
  createForm: Form;
  createIncident: Incident;
  createIncidentCategory: IncidentCategory;
  createIncidentLabel: Label;
  createLabel: Label;
  createLocation: Location;
  createOrganization: Organization;
  createParticipant: Participant;
  createParticipantBehaviour: ParticipantBehaviour;
  createParticipantBehaviourRecording: ParticipantBehaviourRecording;
  createParticipantDocument: ParticipantDocument;
  createParticipantDocumentLabel: Label;
  createParticipantEmbeddableForm: ParticipantEmbeddableForm;
  createParticipantFieldGroupTemplate: ParticipantFieldGroupTemplate;
  createParticipantFieldTemplate: ParticipantFieldTemplate;
  createParticipantFileLabel: Label;
  createParticipantLabel: Label;
  createParticipantNote: ParticipantNote;
  createParticipantNoteLabel: Label;
  createParticipantQr: ParticipantQr;
  createParticipantQrLabel: Label;
  createParticipantRestrictivePractice: ParticipantRestrictivePractice;
  createParticipantRestrictivePracticeLabel: Label;
  createParticipantTask: ParticipantTask;
  createParticipantTaskLabel: Label;
  createParticipantTaskTemplate: ParticipantTaskTemplate;
  createParticipantTaskTemplateLabel: Label;
  createParticipantTasksFromTemplates: Array<ParticipantTask>;
  createParticipantUser: ParticipantUser;
  createParticipantUserLabel: Label;
  createParticipantUsers: Array<ParticipantUser>;
  createPasswordChangeTicketUrl: Scalars['String']['output'];
  createTemplate: Template;
  deleteForm: Maybe<Form>;
  deleteIncident: Maybe<Incident>;
  deleteIncidentCategory: Maybe<IncidentCategory>;
  deleteIncidentFile: Maybe<IncidentFile>;
  deleteIncidentFiles: Array<IncidentFile>;
  deleteIncidentLabel: Maybe<Label>;
  deleteLabel: Maybe<Label>;
  deleteLocation: Maybe<Location>;
  deleteParticipant: Maybe<Participant>;
  deleteParticipantBehaviour: Maybe<ParticipantBehaviour>;
  deleteParticipantBehaviourRecording: Maybe<ParticipantBehaviourRecording>;
  deleteParticipantDocument: Maybe<ParticipantDocument>;
  deleteParticipantDocumentLabel: Maybe<Label>;
  deleteParticipantDocuments: Array<ParticipantDocument>;
  deleteParticipantEmbeddableForm: Maybe<ParticipantEmbeddableForm>;
  deleteParticipantFieldGroupTemplate: Maybe<ParticipantFieldGroupTemplate>;
  deleteParticipantFieldTemplate: Maybe<ParticipantFieldTemplate>;
  deleteParticipantFile: Maybe<ParticipantFile>;
  deleteParticipantFileLabel: Maybe<Label>;
  deleteParticipantFiles: Array<ParticipantFile>;
  deleteParticipantLabel: Maybe<Label>;
  deleteParticipantNote: Maybe<ParticipantNote>;
  deleteParticipantNoteLabel: Maybe<Label>;
  deleteParticipantQr: Maybe<ParticipantQr>;
  deleteParticipantQrLabel: Maybe<Label>;
  deleteParticipantRestrictivePractice: Maybe<ParticipantRestrictivePractice>;
  deleteParticipantRestrictivePracticeLabel: Maybe<Label>;
  deleteParticipantTask: Maybe<ParticipantTask>;
  deleteParticipantTaskLabel: Maybe<Label>;
  deleteParticipantTaskTemplate: Maybe<ParticipantTaskTemplate>;
  deleteParticipantTaskTemplateLabel: Maybe<Label>;
  deleteParticipantUser: Maybe<ParticipantUser>;
  deleteParticipantUserLabel: Maybe<Label>;
  deleteParticipantUsers: Array<ParticipantUser>;
  deleteUser: Maybe<User>;
  exportIncidents: Job;
  exportParticipant: Job;
  exportParticipants: Job;
  fastForwardParticipant: Participant;
  generateIncidentPdf: Pdf;
  generateParticipantDocumentPdf: Pdf;
  inviteUser: User;
  notifyParticipantDocumentAuthors: Scalars['Boolean']['output'];
  notifyParticipantDocumentReviewers: Scalars['Boolean']['output'];
  reprocessFormResponse: Scalars['Boolean']['output'];
  requestResetMfaEmail: Scalars['Boolean']['output'];
  resendInviteEmail: Scalars['Boolean']['output'];
  restoreParticipantDocumentVersion: ParticipantDocument;
  restoreParticipantNoteVersion: ParticipantDocument;
  restoreTemplateVersion: Template;
  scoreParticipantDocument: Job;
  updateForm: Form;
  updateIncident: Incident;
  updateIncidentCategory: IncidentCategory;
  updateIncidentFile: IncidentFile;
  updateIncidentStatus: Incident;
  updateLabel: Label;
  updateLocation: Location;
  updateOrganization: Organization;
  updateParticipant: Participant;
  updateParticipantBehaviour: ParticipantBehaviour;
  updateParticipantBehaviourRecording: ParticipantBehaviourRecording;
  updateParticipantDocument: ParticipantDocument;
  updateParticipantEmbeddableForm: ParticipantEmbeddableForm;
  updateParticipantFieldGroupTemplate: ParticipantFieldTemplate;
  updateParticipantFieldTemplate: ParticipantFieldTemplate;
  updateParticipantFile: ParticipantFile;
  updateParticipantNote: ParticipantNote;
  updateParticipantQr: ParticipantQr;
  updateParticipantRestrictivePractice: ParticipantRestrictivePractice;
  updateParticipantTask: ParticipantTask;
  updateParticipantTaskTemplate: ParticipantTaskTemplate;
  updateParticipantWidgetLayoutItems: Array<ParticipantWidgetLayoutItem>;
  updateTemplate: Template;
  updateUser: User;
};

export type MutationCloneParticipantDocumentArgs = {
  organizationId: Scalars['ID']['input'];
  participantDocumentId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};

export type MutationCloneParticipantNoteArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  participantNoteId: Scalars['ID']['input'];
};

export type MutationCreateFormArgs = {
  organizationId: Scalars['ID']['input'];
  request: CreateFormRequest;
};

export type MutationCreateIncidentArgs = {
  organizationId: Scalars['ID']['input'];
  request: CreateIncidentRequest;
};

export type MutationCreateIncidentCategoryArgs = {
  organizationId: Scalars['ID']['input'];
  request: CreateIncidentCategoryRequest;
};

export type MutationCreateIncidentLabelArgs = {
  incidentId: Scalars['ID']['input'];
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationCreateLabelArgs = {
  organizationId: Scalars['ID']['input'];
  request: CreateLabelRequest;
};

export type MutationCreateLocationArgs = {
  organizationId: Scalars['ID']['input'];
  request: CreateLocationRequest;
};

export type MutationCreateOrganizationArgs = {
  request: CreateOrganizationRequest;
};

export type MutationCreateParticipantArgs = {
  request: CreateParticipantRequest;
};

export type MutationCreateParticipantBehaviourArgs = {
  organizationId: Scalars['ID']['input'];
  request: CreateParticipantBehaviourRequest;
};

export type MutationCreateParticipantBehaviourRecordingArgs = {
  organizationId: Scalars['ID']['input'];
  participantBehaviourId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  request: CreateParticipantBehaviourRecordingRequest;
};

export type MutationCreateParticipantDocumentArgs = {
  organizationId: Scalars['ID']['input'];
  request: CreateParticipantDocumentRequest;
};

export type MutationCreateParticipantDocumentLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantDocumentId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};

export type MutationCreateParticipantEmbeddableFormArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  request: CreateParticipantEmbeddableFormRequest;
};

export type MutationCreateParticipantFieldGroupTemplateArgs = {
  organizationId: Scalars['ID']['input'];
  request: CreateParticipantFieldGroupTemplateRequest;
};

export type MutationCreateParticipantFieldTemplateArgs = {
  organizationId: Scalars['ID']['input'];
  request: CreateParticipantFieldTemplateRequest;
};

export type MutationCreateParticipantFileLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantFileId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};

export type MutationCreateParticipantLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};

export type MutationCreateParticipantNoteArgs = {
  organizationId: Scalars['ID']['input'];
  request: CreateParticipantNoteRequest;
};

export type MutationCreateParticipantNoteLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  participantNoteId: Scalars['ID']['input'];
};

export type MutationCreateParticipantQrArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  request: CreateParticipantQrRequest;
};

export type MutationCreateParticipantQrLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  qrId: Scalars['ID']['input'];
};

export type MutationCreateParticipantRestrictivePracticeArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  request: CreateParticipantRestrictivePracticeRequest;
};

export type MutationCreateParticipantRestrictivePracticeLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  restrictivePracticeId: Scalars['ID']['input'];
};

export type MutationCreateParticipantTaskArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  request: CreateParticipantTaskRequest;
};

export type MutationCreateParticipantTaskLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  participantTaskId: Scalars['ID']['input'];
};

export type MutationCreateParticipantTaskTemplateArgs = {
  organizationId: Scalars['ID']['input'];
  request: CreateParticipantTaskTemplateRequest;
};

export type MutationCreateParticipantTaskTemplateLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  participantTaskTemplateId: Scalars['ID']['input'];
};

export type MutationCreateParticipantTasksFromTemplatesArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  request: CreateParticipantTasksFromTemplatesRequest;
};

export type MutationCreateParticipantUserArgs = {
  organizationId: Scalars['ID']['input'];
  request: CreateParticipantUserRequest;
};

export type MutationCreateParticipantUserLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  participantUserId: Scalars['ID']['input'];
};

export type MutationCreateParticipantUsersArgs = {
  organizationId: Scalars['ID']['input'];
  requests: Array<CreateParticipantUserRequest>;
};

export type MutationCreatePasswordChangeTicketUrlArgs = {
  organizationId: Scalars['ID']['input'];
};

export type MutationCreateTemplateArgs = {
  organizationId: Scalars['ID']['input'];
  request: CreateTemplateRequest;
};

export type MutationDeleteFormArgs = {
  formId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationDeleteIncidentArgs = {
  incidentId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationDeleteIncidentCategoryArgs = {
  categoryId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationDeleteIncidentFileArgs = {
  incidentFileId: Scalars['ID']['input'];
  incidentId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationDeleteIncidentFilesArgs = {
  incidentFileIds: Array<Scalars['ID']['input']>;
  incidentId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationDeleteIncidentLabelArgs = {
  incidentId: Scalars['ID']['input'];
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationDeleteLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationDeleteLocationArgs = {
  locationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantBehaviourArgs = {
  organizationId: Scalars['ID']['input'];
  participantBehaviourId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantBehaviourRecordingArgs = {
  organizationId: Scalars['ID']['input'];
  participantBehaviourId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  recordingId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantDocumentArgs = {
  organizationId: Scalars['ID']['input'];
  participantDocumentId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantDocumentLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantDocumentId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantDocumentsArgs = {
  organizationId: Scalars['ID']['input'];
  participantDocumentIds: Array<Scalars['ID']['input']>;
  participantId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantEmbeddableFormArgs = {
  organizationId: Scalars['ID']['input'];
  participantEmbeddableFormId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantFieldGroupTemplateArgs = {
  organizationId: Scalars['ID']['input'];
  participantFieldGroupTemplateId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantFieldTemplateArgs = {
  organizationId: Scalars['ID']['input'];
  participantFieldTemplateId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantFileArgs = {
  organizationId: Scalars['ID']['input'];
  participantFileId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantFileLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantFileId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantFilesArgs = {
  organizationId: Scalars['ID']['input'];
  participantFileIds: Array<Scalars['ID']['input']>;
  participantId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantNoteArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  participantNoteId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantNoteLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  participantNoteId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantQrArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  qrId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantQrLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  qrId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantRestrictivePracticeArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  restrictivePracticeId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantRestrictivePracticeLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  restrictivePracticeId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantTaskArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  participantTaskId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantTaskLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  participantTaskId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantTaskTemplateArgs = {
  organizationId: Scalars['ID']['input'];
  participantTaskTemplateId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantTaskTemplateLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  participantTaskTemplateId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantUserArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantUserLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  participantUserId: Scalars['ID']['input'];
};

export type MutationDeleteParticipantUsersArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type MutationDeleteUserArgs = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationExportIncidentsArgs = {
  organizationId: Scalars['ID']['input'];
  request?: InputMaybe<GetPaginatedIncidentsRequest>;
};

export type MutationExportParticipantArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  request: ExportParticipantRequest;
};

export type MutationExportParticipantsArgs = {
  organizationId: Scalars['ID']['input'];
  request?: InputMaybe<GetPaginatedParticipantsRequest>;
};

export type MutationFastForwardParticipantArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};

export type MutationGenerateIncidentPdfArgs = {
  incidentId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationGenerateParticipantDocumentPdfArgs = {
  organizationId: Scalars['ID']['input'];
  participantDocumentId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};

export type MutationInviteUserArgs = {
  request: InviteUserRequest;
};

export type MutationNotifyParticipantDocumentAuthorsArgs = {
  organizationId: Scalars['ID']['input'];
  participantDocumentId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationNotifyParticipantDocumentReviewersArgs = {
  organizationId: Scalars['ID']['input'];
  participantDocumentId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationReprocessFormResponseArgs = {
  formResponseId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type MutationRequestResetMfaEmailArgs = {
  email: Scalars['String']['input'];
};

export type MutationResendInviteEmailArgs = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationRestoreParticipantDocumentVersionArgs = {
  organizationId: Scalars['ID']['input'];
  participantDocumentId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  versionId: Scalars['ID']['input'];
};

export type MutationRestoreParticipantNoteVersionArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  participantNoteId: Scalars['ID']['input'];
  versionId: Scalars['ID']['input'];
};

export type MutationRestoreTemplateVersionArgs = {
  organizationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  versionId: Scalars['ID']['input'];
};

export type MutationScoreParticipantDocumentArgs = {
  organizationId: Scalars['ID']['input'];
  participantDocumentId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
};

export type MutationUpdateFormArgs = {
  formId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  request: UpdateFormRequest;
};

export type MutationUpdateIncidentArgs = {
  incidentId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  request: UpdateIncidentRequest;
};

export type MutationUpdateIncidentCategoryArgs = {
  categoryId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  request: UpdateIncidentCategoryRequest;
};

export type MutationUpdateIncidentFileArgs = {
  incidentFileId: Scalars['ID']['input'];
  incidentId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  request: UpdateIncidentFileRequest;
};

export type MutationUpdateIncidentStatusArgs = {
  incidentId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  request: UpdateIncidentStatusRequest;
};

export type MutationUpdateLabelArgs = {
  labelId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  request: UpdateLabelRequest;
};

export type MutationUpdateLocationArgs = {
  locationId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  request: UpdateLocationRequest;
};

export type MutationUpdateOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
  request: UpdateOrganizationRequest;
};

export type MutationUpdateParticipantArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  request: UpdateParticipantRequest;
};

export type MutationUpdateParticipantBehaviourArgs = {
  organizationId: Scalars['ID']['input'];
  participantBehaviourId: Scalars['ID']['input'];
  request: UpdateParticipantBehaviourRequest;
};

export type MutationUpdateParticipantBehaviourRecordingArgs = {
  organizationId: Scalars['ID']['input'];
  participantBehaviourId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  recordingId: Scalars['ID']['input'];
  request: UpdateParticipantBehaviourRecordingRequest;
};

export type MutationUpdateParticipantDocumentArgs = {
  organizationId: Scalars['ID']['input'];
  participantDocumentId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  request: UpdateParticipantDocumentRequest;
};

export type MutationUpdateParticipantEmbeddableFormArgs = {
  organizationId: Scalars['ID']['input'];
  participantEmbeddableFormId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  request: UpdateParticipantEmbeddableFormRequest;
};

export type MutationUpdateParticipantFieldGroupTemplateArgs = {
  organizationId: Scalars['ID']['input'];
  participantFieldGroupTemplateId: Scalars['ID']['input'];
  request: UpdateParticipantFieldGroupTemplateRequest;
};

export type MutationUpdateParticipantFieldTemplateArgs = {
  organizationId: Scalars['ID']['input'];
  participantFieldTemplateId: Scalars['ID']['input'];
  request: UpdateParticipantFieldTemplateRequest;
};

export type MutationUpdateParticipantFileArgs = {
  organizationId: Scalars['ID']['input'];
  participantFileId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  request: UpdateParticipantFileRequest;
};

export type MutationUpdateParticipantNoteArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  participantNoteId: Scalars['ID']['input'];
  request: UpdateParticipantNoteRequest;
};

export type MutationUpdateParticipantQrArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  qrId: Scalars['ID']['input'];
  request: UpdateParticipantQrRequest;
};

export type MutationUpdateParticipantRestrictivePracticeArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  request: UpdateParticipantRestrictivePracticeRequest;
  restrictivePracticeId: Scalars['ID']['input'];
};

export type MutationUpdateParticipantTaskArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  participantTaskId: Scalars['ID']['input'];
  request: UpdateParticipantTaskRequest;
};

export type MutationUpdateParticipantTaskTemplateArgs = {
  organizationId: Scalars['ID']['input'];
  participantTaskTemplateId: Scalars['ID']['input'];
  request: UpdateParticipantTaskTemplateRequest;
};

export type MutationUpdateParticipantWidgetLayoutItemsArgs = {
  organizationId: Scalars['ID']['input'];
  participantId: Scalars['ID']['input'];
  request: Array<UpdateParticipantWidgetLayoutItemRequest>;
};

export type MutationUpdateTemplateArgs = {
  organizationId: Scalars['ID']['input'];
  request: UpdateTemplateRequest;
  templateId: Scalars['ID']['input'];
};

export type MutationUpdateUserArgs = {
  organizationId: Scalars['ID']['input'];
  request: UpdateUserRequest;
  userId: Scalars['ID']['input'];
};

export type Organization = {
  __typename?: 'Organization';
  auditTrail: PaginatedAuditTrailEntries;
  createdAt: Scalars['DateTime']['output'];
  featureFlags: Array<FeatureFlag>;
  form: Maybe<Form>;
  forms: Array<Form>;
  id: Scalars['ID']['output'];
  incident: Maybe<Incident>;
  incidentCategories: Array<IncidentCategory>;
  incidents: PaginatedIncidents;
  job: Maybe<Job>;
  label: Maybe<Label>;
  labels: Array<Label>;
  locale: Scalars['String']['output'];
  location: Maybe<Location>;
  locations: Array<Location>;
  logo: Maybe<Scalars['String']['output']>;
  mfaPolicy: MfaPolicy;
  name: Scalars['String']['output'];
  participant: Maybe<Participant>;
  participantFieldGroupTemplate: Maybe<ParticipantFieldGroupTemplate>;
  participantFieldGroupTemplates: Array<ParticipantFieldGroupTemplate>;
  participantTaskTemplate: Maybe<ParticipantTaskTemplate>;
  participantTaskTemplates: Array<ParticipantTaskTemplate>;
  participants: PaginatedParticipants;
  status: OrganizationStatus;
  stripeCustomerId: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId: Maybe<Scalars['String']['output']>;
  template: Maybe<Template>;
  templates: PaginatedTemplates;
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: Maybe<User>;
  users: PaginatedUsers;
};

export type OrganizationAuditTrailArgs = {
  request?: InputMaybe<GetPaginatedAuditTrailEntriesRequest>;
};

export type OrganizationFormArgs = {
  formId: Scalars['ID']['input'];
};

export type OrganizationIncidentArgs = {
  incidentId: Scalars['ID']['input'];
};

export type OrganizationIncidentsArgs = {
  request?: InputMaybe<GetPaginatedIncidentsRequest>;
};

export type OrganizationJobArgs = {
  jobId: Scalars['ID']['input'];
};

export type OrganizationLabelArgs = {
  labelId: Scalars['ID']['input'];
};

export type OrganizationLabelsArgs = {
  type: Array<LabelType>;
};

export type OrganizationLocationArgs = {
  locationId: Scalars['ID']['input'];
};

export type OrganizationParticipantArgs = {
  participantId: Scalars['ID']['input'];
};

export type OrganizationParticipantFieldGroupTemplateArgs = {
  participantFieldGroupTemplateId: Scalars['ID']['input'];
};

export type OrganizationParticipantTaskTemplateArgs = {
  participantTaskTemplateId: Scalars['ID']['input'];
};

export type OrganizationParticipantsArgs = {
  request?: InputMaybe<GetPaginatedParticipantsRequest>;
};

export type OrganizationTemplateArgs = {
  templateId: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganizationTemplatesArgs = {
  request?: InputMaybe<GetPaginatedTemplatesRequest>;
};

export type OrganizationUserArgs = {
  userId: Scalars['ID']['input'];
};

export type OrganizationUsersArgs = {
  request?: InputMaybe<GetPaginatedUsersRequest>;
};

export type OrganizationMembership = {
  __typename?: 'OrganizationMembership';
  locations: Array<Location>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  roles: Array<Role>;
};

export type OrganizationMinimal = {
  __typename?: 'OrganizationMinimal';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  logo: Maybe<Scalars['String']['output']>;
  mfaPolicy: MfaPolicy;
  name: Scalars['String']['output'];
  status: OrganizationStatus;
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrganizationRecordingInfo = {
  __typename?: 'OrganizationRecordingInfo';
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  logo: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  participant: Maybe<ParticipantRecordingInfo>;
  participants: PaginatedParticipantRecordingInfo;
  timezone: Scalars['String']['output'];
};

export type OrganizationRecordingInfoParticipantArgs = {
  participantId: Scalars['ID']['input'];
  qrId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganizationRecordingInfoParticipantsArgs = {
  request: GetParticipantRecordingInfoRequest;
};

export enum OrganizationStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  NonBillable = 'NON_BILLABLE',
  Suspended = 'SUSPENDED',
  Trial = 'TRIAL',
}

export type PaginatedAuditTrailEntries = {
  __typename?: 'PaginatedAuditTrailEntries';
  pagination: Maybe<TimestampPagination>;
  results: Array<AuditTrailEntry>;
};

export type PaginatedIncidents = {
  __typename?: 'PaginatedIncidents';
  pagination: Pagination;
  results: Array<Incident>;
};

export type PaginatedParticipantAuditTrailEntries = {
  __typename?: 'PaginatedParticipantAuditTrailEntries';
  pagination: TimestampPagination;
  results: Array<AuditTrailEntry>;
};

export type PaginatedParticipantDocumentVersions = {
  __typename?: 'PaginatedParticipantDocumentVersions';
  pagination: Pagination;
  results: Array<ParticipantDocumentVersion>;
};

export type PaginatedParticipantNoteVersions = {
  __typename?: 'PaginatedParticipantNoteVersions';
  pagination: Pagination;
  results: Array<ParticipantNoteVersion>;
};

export type PaginatedParticipantNotes = {
  __typename?: 'PaginatedParticipantNotes';
  pagination: Pagination;
  results: Array<ParticipantNote>;
};

export type PaginatedParticipantRecordingInfo = {
  __typename?: 'PaginatedParticipantRecordingInfo';
  pagination: Pagination;
  results: Array<ParticipantRecordingInfo>;
};

export type PaginatedParticipants = {
  __typename?: 'PaginatedParticipants';
  pagination: Pagination;
  results: Array<Participant>;
};

export type PaginatedTemplateVersions = {
  __typename?: 'PaginatedTemplateVersions';
  pagination: Pagination;
  results: Array<TemplateVersion>;
};

export type PaginatedTemplates = {
  __typename?: 'PaginatedTemplates';
  pagination: Pagination;
  results: Array<Template>;
};

export type PaginatedUsers = {
  __typename?: 'PaginatedUsers';
  pagination: Pagination;
  results: Array<User>;
};

export type Pagination = {
  __typename?: 'Pagination';
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginationRequest = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Participant = {
  __typename?: 'Participant';
  address: Maybe<Scalars['String']['output']>;
  assignedUsers: Array<ParticipantUser>;
  behaviour: Maybe<ParticipantBehaviour>;
  behaviours: Array<ParticipantBehaviour>;
  createdAt: Scalars['DateTime']['output'];
  dob: Scalars['DateTime']['output'];
  document: Maybe<ParticipantDocument>;
  documents: Array<ParticipantDocument>;
  email: Maybe<Scalars['String']['output']>;
  embeddableForms: Array<ParticipantEmbeddableForm>;
  entries: PaginatedParticipantAuditTrailEntries;
  fieldGroups: Array<ParticipantFieldGroup>;
  file: Maybe<ParticipantFile>;
  files: Array<ParticipantFile>;
  firstName: Scalars['String']['output'];
  gender: Gender;
  id: Scalars['ID']['output'];
  isOnLatestFields: Scalars['Boolean']['output'];
  keyContacts: Array<ParticipantKeyContact>;
  label: Maybe<Label>;
  labels: Array<Label>;
  lastName: Scalars['String']['output'];
  location: Location;
  ndisNumber: Maybe<Scalars['String']['output']>;
  note: Maybe<ParticipantNote>;
  notes: PaginatedParticipantNotes;
  organizationId: Scalars['ID']['output'];
  phone: Maybe<Scalars['String']['output']>;
  picture: Maybe<Scalars['String']['output']>;
  postcode: Maybe<Scalars['String']['output']>;
  qrs: Array<ParticipantQr>;
  restrictivePractices: Array<ParticipantRestrictivePractice>;
  state: Maybe<Scalars['String']['output']>;
  status: ParticipantStatus;
  statusChangeEvents: Array<ParticipantStatusChangeEvent>;
  suburb: Maybe<Scalars['String']['output']>;
  task: Maybe<ParticipantTask>;
  tasks: Array<ParticipantTask>;
  updatedAt: Scalars['DateTime']['output'];
  widgets: Array<ParticipantWidgetLayoutItem>;
};

export type ParticipantBehaviourArgs = {
  participantBehaviourId: Scalars['ID']['input'];
};

export type ParticipantDocumentArgs = {
  participantDocumentId: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};

export type ParticipantEntriesArgs = {
  request?: InputMaybe<GetPaginatedParticipantAuditTrailEntriesRequest>;
};

export type ParticipantFileArgs = {
  participantFileId: Scalars['ID']['input'];
};

export type ParticipantLabelArgs = {
  labelId: Scalars['ID']['input'];
};

export type ParticipantNoteArgs = {
  participantNoteId: Scalars['ID']['input'];
  versionId?: InputMaybe<Scalars['ID']['input']>;
};

export type ParticipantNotesArgs = {
  request?: InputMaybe<GetPaginatedParticipantNotesRequest>;
};

export type ParticipantTaskArgs = {
  participantTaskId: Scalars['ID']['input'];
};

export type ParticipantBehaviour = {
  __typename?: 'ParticipantBehaviour';
  description: Scalars['String']['output'];
  example: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  methods: ParticipantBehaviourMethods;
  name: Scalars['String']['output'];
  nonExample: Scalars['String']['output'];
  recordings: Array<ParticipantBehaviourRecording>;
  status: ParticipantBehaviourStatus;
};

export type ParticipantBehaviourDataSource = {
  __typename?: 'ParticipantBehaviourDataSource';
  method: MethodType;
  participantBehaviourId: Scalars['ID']['output'];
};

export type ParticipantBehaviourInfo = {
  __typename?: 'ParticipantBehaviourInfo';
  description: Scalars['String']['output'];
  example: Scalars['String']['output'];
  history: Array<ParticipantBehaviourRecording>;
  id: Scalars['ID']['output'];
  methods: ParticipantBehaviourMethodsInfo;
  name: Scalars['String']['output'];
  nonExample: Scalars['String']['output'];
  status: ParticipantBehaviourStatus;
};

export type ParticipantBehaviourMethods = {
  __typename?: 'ParticipantBehaviourMethods';
  abc: AbcMethod;
  duration: DurationMethod;
  episodicSeverity: EpisodicSeverityMethod;
  frequency: FrequencyMethod;
};

export type ParticipantBehaviourMethodsInfo = {
  __typename?: 'ParticipantBehaviourMethodsInfo';
  abc: RecordingAbcMethod;
  duration: RecordingDurationMethod;
  episodicSeverity: RecordingEpisodicSeverityMethod;
  frequency: RecordingFrequencyMethod;
};

export type ParticipantBehaviourRecording =
  | ParticipantBehaviourRecordingAbc
  | ParticipantBehaviourRecordingDuration
  | ParticipantBehaviourRecordingEpisodicSeverity
  | ParticipantBehaviourRecordingFrequency;

export type ParticipantBehaviourRecordingAbc = {
  __typename?: 'ParticipantBehaviourRecordingAbc';
  antecedent: Scalars['String']['output'];
  behaviour: Scalars['String']['output'];
  comment: Maybe<Scalars['String']['output']>;
  consequence: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  method: AbcMethod;
  participantBehaviourId: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
  user: RecordingUser;
};

export type ParticipantBehaviourRecordingDuration = {
  __typename?: 'ParticipantBehaviourRecordingDuration';
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  method: DurationMethod;
  participantBehaviourId: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
  user: RecordingUser;
  value: Scalars['Int']['output'];
};

export type ParticipantBehaviourRecordingEpisodicSeverity = {
  __typename?: 'ParticipantBehaviourRecordingEpisodicSeverity';
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  method: EpisodicSeverityMethod;
  participantBehaviourId: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
  user: RecordingUser;
  value: Scalars['Int']['output'];
};

export type ParticipantBehaviourRecordingFrequency = {
  __typename?: 'ParticipantBehaviourRecordingFrequency';
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  method: FrequencyMethod;
  participantBehaviourId: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
  user: RecordingUser;
  value: Scalars['Int']['output'];
};

export enum ParticipantBehaviourStatus {
  Active = 'Active',
  Archived = 'Archived',
}

export type ParticipantDocument = {
  __typename?: 'ParticipantDocument';
  authors: Array<User>;
  createdAt: Scalars['DateTime']['output'];
  creator: User;
  id: Scalars['ID']['output'];
  label: Maybe<Label>;
  labels: Array<Label>;
  name: Scalars['String']['output'];
  participantId: Scalars['ID']['output'];
  reviewers: Array<User>;
  scoringResult: Maybe<ParticipantDocumentScoringResult>;
  status: ParticipantDocumentStatus;
  template: Maybe<Template>;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['JSON']['output'];
  variables: Array<Variable>;
  version: Maybe<ParticipantDocumentVersion>;
  versionId: Maybe<Scalars['ID']['output']>;
  versions: PaginatedParticipantDocumentVersions;
};

export type ParticipantDocumentLabelArgs = {
  labelId: Scalars['ID']['input'];
};

export type ParticipantDocumentVersionsArgs = {
  request?: InputMaybe<GetPaginatedParticipantDocumentVersionsRequest>;
};

export type ParticipantDocumentScoringResult = {
  __typename?: 'ParticipantDocumentScoringResult';
  checklist: ScoringChecklist;
  inputCachedTokens: Scalars['Int']['output'];
  inputNonCachedTokens: Scalars['Int']['output'];
  outputTokens: Scalars['Int']['output'];
  results: Array<ScoringCriteriaResult>;
};

export enum ParticipantDocumentStatus {
  Draft = 'DRAFT',
  Finalized = 'FINALIZED',
}

export type ParticipantDocumentVersion = {
  __typename?: 'ParticipantDocumentVersion';
  createdAt: Scalars['DateTime']['output'];
  users: Array<User>;
  versionId: Scalars['ID']['output'];
};

export type ParticipantEmbeddableForm = {
  __typename?: 'ParticipantEmbeddableForm';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type ParticipantField = {
  __typename?: 'ParticipantField';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  template: ParticipantFieldTemplate;
  updatedAt: Scalars['DateTime']['output'];
  value: Maybe<Scalars['JSON']['output']>;
};

export type ParticipantFieldGroup = {
  __typename?: 'ParticipantFieldGroup';
  createdAt: Scalars['DateTime']['output'];
  fields: Array<ParticipantField>;
  id: Scalars['ID']['output'];
  template: ParticipantFieldGroupTemplate;
  updatedAt: Scalars['DateTime']['output'];
};

export type ParticipantFieldGroupTemplate = {
  __typename?: 'ParticipantFieldGroupTemplate';
  createdAt: Scalars['DateTime']['output'];
  fields: Array<ParticipantFieldTemplate>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versionId: Scalars['ID']['output'];
};

export type ParticipantFieldTemplate = {
  __typename?: 'ParticipantFieldTemplate';
  attributes: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: FieldTemplateType;
  updatedAt: Scalars['DateTime']['output'];
  versionId: Scalars['ID']['output'];
};

export type ParticipantFile = {
  __typename?: 'ParticipantFile';
  createdAt: Scalars['DateTime']['output'];
  downloadUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Maybe<Label>;
  labels: Array<Label>;
  name: Scalars['String']['output'];
  participantId: Scalars['ID']['output'];
  size: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploader: Maybe<User>;
  viewUrl: Scalars['String']['output'];
};

export type ParticipantFileLabelArgs = {
  labelId: Scalars['ID']['input'];
};

export type ParticipantKeyContact = {
  __typename?: 'ParticipantKeyContact';
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  labels: Array<Label>;
  name: Scalars['String']['output'];
  phone: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ParticipantNote = {
  __typename?: 'ParticipantNote';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  labels: Array<Label>;
  participantId: Scalars['ID']['output'];
  template: Maybe<Template>;
  updatedAt: Scalars['DateTime']['output'];
  user: Maybe<User>;
  value: Scalars['JSON']['output'];
  version: Maybe<ParticipantNoteVersion>;
  versionId: Maybe<Scalars['ID']['output']>;
  versions: PaginatedParticipantNoteVersions;
};

export type ParticipantNoteVersionsArgs = {
  request?: InputMaybe<GetPaginatedParticipantNoteVersionsRequest>;
};

export type ParticipantNoteVersion = {
  __typename?: 'ParticipantNoteVersion';
  createdAt: Scalars['DateTime']['output'];
  users: Array<User>;
  versionId: Scalars['ID']['output'];
};

export type ParticipantQr = {
  __typename?: 'ParticipantQr';
  behaviours: Array<ParticipantQrBehaviour>;
  createdAt: Scalars['DateTime']['output'];
  embeddableForms: Array<ParticipantEmbeddableForm>;
  id: Scalars['ID']['output'];
  labels: Array<Label>;
  name: Scalars['String']['output'];
  status: ParticipantQrStatus;
  updatedAt: Scalars['DateTime']['output'];
  users: Array<UnauthedRecordingUser>;
};

export type ParticipantQrBehaviour = {
  __typename?: 'ParticipantQrBehaviour';
  description: Scalars['String']['output'];
  example: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  methods: ParticipantQrBehaviourMethods;
  name: Scalars['String']['output'];
  nonExample: Scalars['String']['output'];
  recordings: Array<ParticipantQrBehaviourRecording>;
  status: ParticipantBehaviourStatus;
};

export type ParticipantQrBehaviourMethods = {
  __typename?: 'ParticipantQrBehaviourMethods';
  abc: AbcMethod;
  duration: DurationMethod;
  episodicSeverity: EpisodicSeverityMethod;
  frequency: FrequencyMethod;
};

export type ParticipantQrBehaviourRecording =
  | ParticipantBehaviourRecordingAbc
  | ParticipantBehaviourRecordingDuration
  | ParticipantBehaviourRecordingEpisodicSeverity
  | ParticipantBehaviourRecordingFrequency;

export enum ParticipantQrStatus {
  Active = 'Active',
  Archived = 'Archived',
}

export type ParticipantRecordingEmbeddableForm = {
  __typename?: 'ParticipantRecordingEmbeddableForm';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
};

export type ParticipantRecordingInfo = {
  __typename?: 'ParticipantRecordingInfo';
  behaviours: Array<ParticipantBehaviourInfo>;
  createdAt: Scalars['DateTime']['output'];
  dob: Scalars['DateTime']['output'];
  embeddableForms: Array<ParticipantRecordingEmbeddableForm>;
  firstName: Scalars['String']['output'];
  gender: Gender;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  ndisNumber: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  picture: Maybe<Scalars['String']['output']>;
  qr: Maybe<RecordingQr>;
  status: ParticipantStatus;
};

export type ParticipantRestrictivePractice = {
  __typename?: 'ParticipantRestrictivePractice';
  ceasedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  identifiedAt: Scalars['DateTime']['output'];
  labels: Array<Label>;
  startedAt: Maybe<Scalars['DateTime']['output']>;
  status: RestrictivePracticeStatus;
  type: RestrictivePracticeType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum ParticipantStatus {
  Active = 'Active',
  Archived = 'Archived',
  Intake = 'Intake',
  New = 'New',
  OnHold = 'OnHold',
  Waitlist = 'Waitlist',
}

export type ParticipantStatusChangeEvent = {
  __typename?: 'ParticipantStatusChangeEvent';
  status: ParticipantStatus;
  timestamp: Scalars['DateTime']['output'];
};

export type ParticipantTask = {
  __typename?: 'ParticipantTask';
  assignees: Array<User>;
  completedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dueDate: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  labels: Array<Label>;
  name: Scalars['String']['output'];
  participantId: Scalars['ID']['output'];
  recurrence: Maybe<ParticipantTaskRecurrence>;
  requiresDueDate: Maybe<Scalars['Boolean']['output']>;
  status: ParticipantTaskStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type ParticipantTaskRecurrence = {
  __typename?: 'ParticipantTaskRecurrence';
  completedAt: Maybe<Scalars['DateTime']['output']>;
  intervalDays: Scalars['Int']['output'];
};

export enum ParticipantTaskStatus {
  Complete = 'Complete',
  Incomplete = 'Incomplete',
}

export type ParticipantTaskTemplate = {
  __typename?: 'ParticipantTaskTemplate';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  labels: Array<Label>;
  name: Scalars['String']['output'];
  recurrence: Maybe<ParticipantTaskRecurrence>;
  requiresDueDate: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ParticipantUser = {
  __typename?: 'ParticipantUser';
  id: Scalars['ID']['output'];
  labels: Array<Label>;
  user: User;
};

export type ParticipantWidgetLayoutItem = {
  __typename?: 'ParticipantWidgetLayoutItem';
  h: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  w: Scalars['Int']['output'];
  widget: Widget;
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type Pdf = {
  __typename?: 'Pdf';
  downloadUrl: Scalars['String']['output'];
  message: Maybe<Scalars['String']['output']>;
  viewUrl: Scalars['String']['output'];
};

export type PhaseChangeLine = {
  __typename?: 'PhaseChangeLine';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: PhaseChangeType;
};

export enum PhaseChangeType {
  Major = 'Major',
  Minor = 'Minor',
}

export type Query = {
  __typename?: 'Query';
  organization: Maybe<Organization>;
  organizations: Array<OrganizationMinimal>;
  recording: Recording;
  user: Maybe<User>;
};

export type QueryOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};

export type Recording = {
  __typename?: 'Recording';
  authed: Maybe<AuthedRecordingApp>;
  unauthed: UnauthedRecordingApp;
};

export type RecordingAbcMethod = {
  __typename?: 'RecordingAbcMethod';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  templates: AbcTemplate;
};

export type RecordingDurationMethod = {
  __typename?: 'RecordingDurationMethod';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type RecordingEpisodicSeverityMethod = {
  __typename?: 'RecordingEpisodicSeverityMethod';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  scales: Array<RecordingEpisodicSeverityScale>;
};

export type RecordingEpisodicSeverityScale = {
  __typename?: 'RecordingEpisodicSeverityScale';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type RecordingFrequencyMethod = {
  __typename?: 'RecordingFrequencyMethod';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type RecordingMethod =
  | RecordingAbcMethod
  | RecordingDurationMethod
  | RecordingEpisodicSeverityMethod
  | RecordingFrequencyMethod;

export type RecordingPagination = {
  __typename?: 'RecordingPagination';
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type RecordingQr = {
  __typename?: 'RecordingQR';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  participantId: Scalars['ID']['output'];
  status: ParticipantQrStatus;
};

export type RecordingUser = UnauthedRecordingUser | User;

export enum RestrictivePracticeStatus {
  Ceased = 'Ceased',
  Ongoing = 'Ongoing',
}

export enum RestrictivePracticeType {
  ChemicalRestraint = 'ChemicalRestraint',
  EnvironmentalRestraint = 'EnvironmentalRestraint',
  MechanicalRestraint = 'MechanicalRestraint',
  PhysicalRestraint = 'PhysicalRestraint',
  ProhibitedPractice = 'ProhibitedPractice',
  Seclusion = 'Seclusion',
}

export enum Role {
  Administrator = 'Administrator',
  Support = 'Support',
  TeamLeader = 'TeamLeader',
  TeamMember = 'TeamMember',
}

export type ScatterTimeSeries = {
  __typename?: 'ScatterTimeSeries';
  aggregation: AggregationType;
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  source: DataSource;
  symbol: SymbolType;
  trendline: Maybe<Trendline>;
};

export type ScoringChecklist = {
  __typename?: 'ScoringChecklist';
  categories: Array<TemplateScoringCategory>;
  criteriaLabels: Array<CriteriaLabel>;
  id: Scalars['ID']['output'];
  systemPrompt: Scalars['String']['output'];
};

export enum ScoringConfidence {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
}

export type ScoringCriteriaResult = {
  __typename?: 'ScoringCriteriaResult';
  confidence: ScoringConfidence;
  details: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  result: ScoringResult;
};

export enum ScoringResult {
  Failed = 'Failed',
  Passed = 'Passed',
}

export enum SymbolType {
  Circle = 'Circle',
  Diamond = 'Diamond',
  Rect = 'Rect',
  Triangle = 'Triangle',
}

export type TableSeries = {
  __typename?: 'TableSeries';
  id: Scalars['ID']['output'];
  source: DataSource;
};

export type TableWidget = {
  __typename?: 'TableWidget';
  id: Scalars['ID']['output'];
  series: Array<TableSeries>;
  title: Scalars['String']['output'];
};

export type Template = {
  __typename?: 'Template';
  createdAt: Scalars['DateTime']['output'];
  creator: User;
  id: Scalars['ID']['output'];
  labels: Array<Label>;
  name: Scalars['String']['output'];
  scoringChecklist: Maybe<ScoringChecklist>;
  status: TemplateStatus;
  thumbnailUrl: Maybe<Scalars['String']['output']>;
  type: TemplateType;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['JSON']['output'];
  version: Maybe<TemplateVersion>;
  versionId: Maybe<Scalars['ID']['output']>;
  versions: PaginatedTemplateVersions;
};

export type TemplateVersionArgs = {
  versionId: Scalars['ID']['input'];
};

export type TemplateVersionsArgs = {
  request?: InputMaybe<GetPaginatedTemplateVersionsRequest>;
};

export type TemplateScoringCategory = {
  __typename?: 'TemplateScoringCategory';
  criterias: Array<TemplateScoringCriteria>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type TemplateScoringCriteria = {
  __typename?: 'TemplateScoringCriteria';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  labelIds: Array<Scalars['ID']['output']>;
};

export enum TemplateStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export enum TemplateType {
  ParticipantDocument = 'ParticipantDocument',
  ParticipantNote = 'ParticipantNote',
}

export type TemplateVersion = {
  __typename?: 'TemplateVersion';
  createdAt: Scalars['DateTime']['output'];
  users: Array<User>;
  versionId: Scalars['ID']['output'];
};

export type TimeSeries = BarTimeSeries | LineTimeSeries | ScatterTimeSeries;

export type TimeSeriesChartWidget = {
  __typename?: 'TimeSeriesChartWidget';
  id: Scalars['ID']['output'];
  phaseChangeLines: Array<PhaseChangeLine>;
  series: Array<TimeSeries>;
  title: Scalars['String']['output'];
  yAxes: YAxes;
};

export type TimestampPagination = {
  __typename?: 'TimestampPagination';
  firstSeen: Maybe<Scalars['DateTime']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  lastSeen: Maybe<Scalars['DateTime']['output']>;
  limit: Scalars['Int']['output'];
  total: Maybe<Scalars['Int']['output']>;
};

export type TimestampPaginationRequest = {
  firstSeen?: InputMaybe<Scalars['DateTime']['input']>;
  lastSeen?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Trendline = {
  __typename?: 'Trendline';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: TrendlineType;
};

export enum TrendlineType {
  Linear = 'Linear',
  Polynomial = 'Polynomial',
}

export type UnauthedRecordingApp = {
  __typename?: 'UnauthedRecordingApp';
  createParticipantBehaviourRecording: ParticipantBehaviourRecording;
  deleteParticipantBehaviourRecording: Maybe<ParticipantBehaviourRecording>;
  organization: Maybe<OrganizationRecordingInfo>;
  organizations: Array<OrganizationRecordingInfo>;
  qr: Maybe<RecordingQr>;
  updateParticipantBehaviourRecording: ParticipantBehaviourRecording;
};

export type UnauthedRecordingAppCreateParticipantBehaviourRecordingArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  participantBehaviourId: Scalars['ID']['input'];
  qrId: Scalars['ID']['input'];
  request: CreateParticipantBehaviourRecordingRequest;
};

export type UnauthedRecordingAppDeleteParticipantBehaviourRecordingArgs = {
  participantBehaviourId: Scalars['ID']['input'];
  qrId: Scalars['ID']['input'];
  recordingId: Scalars['ID']['input'];
};

export type UnauthedRecordingAppOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};

export type UnauthedRecordingAppOrganizationsArgs = {
  organizationIds: Array<Scalars['ID']['input']>;
};

export type UnauthedRecordingAppQrArgs = {
  qrId: Scalars['ID']['input'];
};

export type UnauthedRecordingAppUpdateParticipantBehaviourRecordingArgs = {
  participantBehaviourId: Scalars['ID']['input'];
  qrId: Scalars['ID']['input'];
  recordingId: Scalars['ID']['input'];
  request: UpdateParticipantBehaviourRecordingRequest;
};

export type UnauthedRecordingUser = {
  __typename?: 'UnauthedRecordingUser';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  qrId: Scalars['ID']['output'];
};

export type UpdateAbcMethodsRequest = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  templates?: InputMaybe<UpdateAbcTemplateRequest>;
};

export type UpdateAbcTemplateRequest = {
  antecedent: Array<Scalars['String']['input']>;
  behaviour: Array<Scalars['String']['input']>;
  consequence: Array<Scalars['String']['input']>;
};

export type UpdateBehaviourRequest = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDurationMethodsRequest = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateEpisodicSeverityMethodsRequest = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  scales?: InputMaybe<Array<UpdateEpisodicSeverityScaleRequest>>;
};

export type UpdateEpisodicSeverityScaleRequest = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateFormRequest = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  labelMappings?: InputMaybe<FormLabelMappingsRequest>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FormType>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFrequencyMethodsRequest = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateIncidentCategoryRequest = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIncidentFileRequest = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIncidentRequest = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ndisReportableIncident?: InputMaybe<Scalars['Boolean']['input']>;
  participantId?: InputMaybe<Scalars['ID']['input']>;
  reviewerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  setting?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<IncidentSeverity>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  witnesses?: InputMaybe<Array<CreateIncidentWitnessInput>>;
};

export type UpdateIncidentStatusRequest = {
  actions?: InputMaybe<Scalars['String']['input']>;
  status: IncidentStatus;
};

export type UpdateLabelRequest = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLocationRequest = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationRequest = {
  featureFlags?: InputMaybe<Array<FeatureFlag>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mfaPolicy?: InputMaybe<MfaPolicy>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrganizationStatus>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParticipantBehaviourMethodsRequest = {
  abc?: InputMaybe<UpdateAbcMethodsRequest>;
  duration?: InputMaybe<UpdateDurationMethodsRequest>;
  episodicSeverity?: InputMaybe<UpdateEpisodicSeverityMethodsRequest>;
  frequency?: InputMaybe<UpdateFrequencyMethodsRequest>;
};

export type UpdateParticipantBehaviourRecordingRequest = {
  comment?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<BehaviourRecordingRequestPayload>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateParticipantBehaviourRequest = {
  description: Scalars['String']['input'];
  example: Scalars['String']['input'];
  methods: UpdateParticipantBehaviourMethodsRequest;
  name: Scalars['String']['input'];
  nonExample: Scalars['String']['input'];
  participantId: Scalars['ID']['input'];
  status: ParticipantBehaviourStatus;
};

export type UpdateParticipantDocumentRequest = {
  authorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  reviewerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<ParticipantDocumentStatus>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateParticipantEmbeddableFormRequest = {
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParticipantFieldGroupRequest = {
  fields: Array<UpdateParticipantFieldRequest>;
  id: Scalars['ID']['input'];
};

export type UpdateParticipantFieldGroupTemplateRequest = {
  index?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParticipantFieldRequest = {
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateParticipantFieldTemplateRequest = {
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  participantFieldGroupTemplateId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<FieldTemplateType>;
};

export type UpdateParticipantFileRequest = {
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParticipantKeyContactRequest = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParticipantNoteRequest = {
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateParticipantQrBehaviourMethodsRequest = {
  abc: UpdateQrAbcMethodsRequest;
  duration: UpdateQrDurationMethodsRequest;
  episodicSeverity: UpdateQrEpisodicSeverityMethodsRequest;
  frequency: UpdateQrFrequencyMethodsRequest;
};

export type UpdateParticipantQrBehaviourRequest = {
  behaviourId: Scalars['ID']['input'];
  methods: UpdateParticipantQrBehaviourMethodsRequest;
};

export type UpdateParticipantQrRequest = {
  behaviours?: InputMaybe<Array<UpdateParticipantQrBehaviourRequest>>;
  embeddableFormIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ParticipantQrStatus>;
};

export type UpdateParticipantRequest = {
  address?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fieldGroups?: InputMaybe<Array<UpdateParticipantFieldGroupRequest>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  keyContacts?: InputMaybe<Array<UpdateParticipantKeyContactRequest>>;
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  ndisNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ParticipantStatus>;
  suburb?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParticipantRestrictivePracticeRequest = {
  ceasedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  identifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<RestrictivePracticeType>;
};

export type UpdateParticipantTaskRecurrenceRequest = {
  intervalDays?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateParticipantTaskRequest = {
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  recurrence?: InputMaybe<UpdateParticipantTaskRecurrenceRequest>;
  requiresDueDate?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ParticipantTaskStatus>;
};

export type UpdateParticipantTaskTemplateRequest = {
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  recurrence?: InputMaybe<UpdateParticipantTaskRecurrenceRequest>;
  requiresDueDate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateParticipantUserRequest = {
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateParticipantWidgetLayoutItemRequest = {
  h: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  w: Scalars['Int']['input'];
  widget: Scalars['JSON']['input'];
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type UpdateQrAbcMethodsRequest = {
  enabled: Scalars['Boolean']['input'];
};

export type UpdateQrDurationMethodsRequest = {
  enabled: Scalars['Boolean']['input'];
};

export type UpdateQrEpisodicSeverityMethodsRequest = {
  enabled: Scalars['Boolean']['input'];
};

export type UpdateQrFrequencyMethodsRequest = {
  enabled: Scalars['Boolean']['input'];
};

export type UpdateTemplateRequest = {
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TemplateStatus>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateUserRequest = {
  email?: InputMaybe<Scalars['String']['input']>;
  featureFlags?: InputMaybe<Array<FeatureFlag>>;
  locations?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  practitionerNumber?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Role>>;
  settings?: InputMaybe<UpdateUserSettingsRequest>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserSettingsRequest = {
  defaultOrganization?: InputMaybe<Scalars['ID']['input']>;
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  extraPermissions: Array<ExtraPermission>;
  featureFlags: Array<FeatureFlag>;
  id: Scalars['ID']['output'];
  intercomHash: Scalars['String']['output'];
  mfaEnrolment: Maybe<MfaEnrolment>;
  name: Scalars['String']['output'];
  organizationMemberships: Array<OrganizationMembership>;
  picture: Maybe<Scalars['String']['output']>;
  practitionerNumber: Maybe<Scalars['String']['output']>;
  settings: UserSettings;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UserSettings = {
  __typename?: 'UserSettings';
  defaultOrganization: Maybe<Scalars['ID']['output']>;
};

export type Variable = {
  __typename?: 'Variable';
  category: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
};

export type Widget = TableWidget | TimeSeriesChartWidget;

export type YAxes = {
  __typename?: 'YAxes';
  left: Maybe<Scalars['Int']['output']>;
  right: Maybe<Scalars['Int']['output']>;
};
